webpackJsonp([0],{

/***/ "+JLh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PersoonlijkeSupervisie_vue__ = __webpack_require__("13Is");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ce46085_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PersoonlijkeSupervisie_vue__ = __webpack_require__("x4QM");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PersoonlijkeSupervisie_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ce46085_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PersoonlijkeSupervisie_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "/Cvj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Scholing_vue__ = __webpack_require__("zoqq");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0812c3b2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Scholing_vue__ = __webpack_require__("Fb8W");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Scholing_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0812c3b2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Scholing_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "/xc6":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bord_majesteit_2.ae42d03.jpg";

/***/ }),

/***/ "13Is":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MainHeader__ = __webpack_require__("ejej");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainFooter__ = __webpack_require__("jJPo");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'Persoonlijke-Supervisie',
	data: function data() {
		return {
			headerImage: __webpack_require__("M9J3")
		};
	},

	computed: {},
	methods: {},
	components: {
		MainHeader: __WEBPACK_IMPORTED_MODULE_0__MainHeader__["a" /* default */], MainFooter: __WEBPACK_IMPORTED_MODULE_1__MainFooter__["a" /* default */]
	}
});

/***/ }),

/***/ "1eB3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__ = __webpack_require__("qLe6");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5064b528_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__ = __webpack_require__("PMxc");
function injectStyle (ssrContext) {
  __webpack_require__("8ESv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5064b528_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "3PQc":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/jongpiramidebord_nl.d930a5d.jpg";

/***/ }),

/***/ "3S7q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MainHeader__ = __webpack_require__("ejej");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainFooter__ = __webpack_require__("jJPo");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'Coaching-Counseling',
	data: function data() {
		return {
			headerImage: __webpack_require__("3kDF"),
			talentenspelBegeleiding1: __webpack_require__("w+BS"),
			talentenspelBegeleiding2: __webpack_require__("KwkG")
		};
	},

	computed: {},
	methods: {},
	components: {
		MainHeader: __WEBPACK_IMPORTED_MODULE_0__MainHeader__["a" /* default */], MainFooter: __WEBPACK_IMPORTED_MODULE_1__MainFooter__["a" /* default */]
	}
});

/***/ }),

/***/ "3kDF":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/talentenspel_begeleiding_header.4280929.jpeg";

/***/ }),

/***/ "7xuk":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/wereldbord_nl.55b8f1a.jpg";

/***/ }),

/***/ "8ESv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "B4SC":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/home_header.1a502fb.jpg";

/***/ }),

/***/ "BvKS":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.5204520.png";

/***/ }),

/***/ "CR37":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('MainHeader',{attrs:{"page":'Scholing'}}),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"whole component"},[_c('img',{attrs:{"src":_vm.headerImage,"width":"938px"}}),_vm._v(" "),_c('h1',[_vm._v("Nascholing")]),_vm._v(" "),_c('p',{staticClass:"highlight"},[_vm._v("Aangesloten bij de Beroepsopleiding TOPKI bied ik de mogelijkheden aan voor therapeuten van het VNT en BVK om het Talentenspel te volgen als nascholing.")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('h2',[_vm._v("Het Talentenspel als Nascholing")]),_vm._v(" "),_c('p',[_vm._v("Het Talentenspel is de leidraad binnen deze nascholing. Het is mogelijk om deel te nemen aan verschillende themadagen van elk 8 uur.")])])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"quarter component"},[_c('img',{staticClass:"gameboard-small",attrs:{"src":_vm.wereldBord}})]),_vm._v(" "),_c('div',{staticClass:"quarter component"},[_c('img',{staticClass:"gameboard-small",attrs:{"src":_vm.levensboomBord}})]),_vm._v(" "),_c('div',{staticClass:"quarter component"},[_c('img',{staticClass:"gameboard-small",attrs:{"src":_vm.piramideBord}})]),_vm._v(" "),_c('div',{staticClass:"quarter component"},[_c('img',{staticClass:"gameboard-small",attrs:{"src":_vm.zielespiegelBord}})])]),_vm._v(" "),_vm._m(4)]),_vm._v(" "),_c('MainFooter',{staticStyle:{"display":"flex","margin-left":"auto","margin-right":"auto"}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"highlight"},[_vm._v("\n\t\t\t\t\t\tTijdelijk neemt Marjon te Riele de trainingen en bijscholingen voor Topki over. Meer informatie op haar\n\t\t\t\t\t\t"),_c('a',{attrs:{"href":"https://www.topki.nl/trainer/marjon-te-riele"}},[_vm._v("Topki pagina")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"half component"},[_c('h2',[_vm._v("Dag 1: "),_c('br'),_vm._v("Talenten ontmoeten")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Het Wereldbord:")]),_vm._v(" Harmonisatie en integratie Het spelen van dit bord zorgt vooral voor innerlijke schoonmaak. Vervorming van talenten worden opgespoord en gezond gemaakt. De positie van de koning(in) wordt verhelderd en bekrachtigd.")]),_vm._v(" "),_c('p',[_vm._v("Op deze themadag gaan we op zoek naar jouw authentieke talenten. Door middel van het spelbord ‘Het koninkrijk’ ga je op zoek naar de talenten die specifiek bij jouw ziel horen,  ga je op zoek naar de onderlinge verhoudingen, de rol van de koning of koningin en jouw leiderschap over je talenten.")])]),_vm._v(" "),_c('div',{staticClass:"half component"},[_c('h2',[_vm._v("Dag 2: "),_c('br'),_vm._v("De Levensboom")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Het Levensboombord:")]),_vm._v(" Inzicht in richting en hiërarchie Het spelen van dit bord zorgt vooral voor uitzicht op de richting van het leven. Je krijgt inzicht op je pad en je doel ofwel je missie, en richtingsgevoel.")]),_vm._v(" "),_c('p',[_vm._v("Deze themadag is een vervolg op de themadag ‘Je talenten ontmoeten’. Nadat het innerlijk koninkrijk uitgespeeld is gaan we over naar het leggen van de levensboom. Hierin wordt inzichtelijk gemaakt op welk niveau de verschillende talenten werken. Er zijn talenten die ingezet worden in relatie met anderen, talenten die specifiek voor jou zijn en talenten die jouw levensmissie ondersteunen. Aan het eind van de dag spreek je jouw levensmissie uit waarmee je het pad van de held op gaat.")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"half component"},[_c('h2',[_vm._v("Dag 3: "),_c('br'),_vm._v("De Piramide")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Het Piramidebord:")]),_vm._v(" Manifestatie en Creatie Het spelen van dit bord voegt een volgende fase toe aan het proces. Dit bord brengt de missie op aarde, het bord van incarnatie, concrete manifestatie van de missie in het dagelijkse leven.")]),_vm._v(" "),_c('p',[_vm._v("Deze themadag is een vervolg op de themadag De Levensboom. Nu gaan we ontdekken hoe de levensmissie gemanifesteerd kan worden. Welke onderlinge wetten spelen mee in de creatie.")])]),_vm._v(" "),_c('div',{staticClass:"half component"},[_c('h2',[_vm._v("Dag 4: "),_c('br'),_vm._v("De Zielespiegel")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Het Zielespiegelbord:")]),_vm._v(" Instrumentatie en zelfrealisatie Het spelen van dit bord brengt de verschillende innerlijke niveaus van de mens bijeen. Men gaat ontdekken dat de missie niet vanuit een drang tot doen kan worden vormgegeven, maar alleen als een spontane uitdrukking van zijn.")]),_vm._v(" "),_c('p',[_vm._v("Tijdens deze themadag ontdekken we de samenhang tussen verschillende gebieden van zijn, bewustzijn en vervuld zijn. We onderzoeken de doorlopende levensmissie richting een zielsmissie. ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"half component"},[_c('h2',[_vm._v("Dag 5: "),_c('br'),_vm._v("Vergeving")]),_vm._v(" "),_c('p',[_vm._v("Tijdens deze themadag leren we dat vergeven een innerlijke reiniging is die uzelf en anderen onschuldig maakt. Het is een prachtige werkwijze die goed toepasbaar is in de praktijk. ")])]),_vm._v(" "),_c('div',{staticClass:"half component"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"whole component"},[_c('h2',[_vm._v("Accredatie")]),_vm._v(" "),_c('p',[_vm._v("De beroepsopleiding "),_c('a',{attrs:{"href":"http://www.topki.nl/trainer/suzette-frijters"}},[_vm._v("TOPKI")]),_vm._v(" is door de SNRO geaccrediteerd. Voor deze beroepsopleiding verzorg ik een aantal scholingsprogramma’s. ")]),_vm._v(" "),_c('p',[_vm._v("De beroepsopleiding TOPKI voldoet aan de internationale voorwaarden van het International Kinesiology College en werkt samen met verschillende nationale- en internationale trainers. In 2012 is de opleiding erkend door de FONG op HBO-niveau. Sinds 2017 heeft de beroepsopleiding TOPKI het keurmerk: FONG.SNRO erkende HBO-opleiding.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ckkg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Fb8W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('MainHeader',{attrs:{"page":'Scholing'}}),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"whole component"},[_c('img',{attrs:{"src":_vm.headerImage,"width":"938px"}}),_vm._v(" "),_c('h1',[_vm._v("Scholing")]),_vm._v(" "),_c('p',{staticClass:"highlight"},[_vm._v("Door de beroepsopleiding TOPKI zijn de volgende scholingen geaccrediteerd die door mij worden verzorgd.")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('h2',[_vm._v("Persoonlijke Supervisie voor studenten in opleiding ")]),_vm._v(" "),_c('p',[_vm._v("Voor studenten aan de beroepsopleiding TOPKI is Persoonlijke Supervisie een verplicht onderdeel in de opleiding. Dit traject is bestemd voor de ondersteuning en ontwikkeling van het persoonlijke groeiproces.")]),_vm._v(" "),_c('h2',[_vm._v("Module Communicatie en Counseling met het Talentenspel voor studenten in opleiding.")]),_vm._v(" "),_c('p',[_vm._v("De module "),_c('router-link',{attrs:{"to":"/scholing/module-communicatie-counseling"}},[_vm._v("Communicatie en Counseling")]),_vm._v(" aan de beroepsopleiding TOPKI bestaat uit vier modules, van elk één dag. In deze vier dagen wordt er gewerkt met het Talentenspel.\n\t\t\t\t\t\t"),_vm._m(1)],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"quarter component"},[_c('img',{staticClass:"gameboard-small",attrs:{"src":_vm.wereldBord}})]),_vm._v(" "),_c('div',{staticClass:"quarter component"},[_c('img',{staticClass:"gameboard-small",attrs:{"src":_vm.levensboomBord}})]),_vm._v(" "),_c('div',{staticClass:"quarter component"},[_c('img',{staticClass:"gameboard-small",attrs:{"src":_vm.piramideBord}})]),_vm._v(" "),_c('div',{staticClass:"quarter component"},[_c('img',{staticClass:"gameboard-small",attrs:{"src":_vm.zielespiegelBord}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"whole component"},[_c('h2',[_vm._v("Nascholing ")]),_vm._v(" "),_c('p',[_vm._v("Aangesloten bij de Beroepsopleiding Topki bied ik de mogelijkheden aan voor therapeuten van het VNT en BVK om het Talentenspel te volgen als "),_c('router-link',{attrs:{"to":"/scholing/nascholing"}},[_vm._v("nascholing")]),_vm._v(".")],1),_vm._v(" "),_c('h2',[_vm._v("Accredatie")]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('p',[_vm._v("De beroepsopleiding TOPKI voldoet aan de internationale voorwaarden van het International Kinesiology College en werkt samen met verschillende nationale- en internationale trainers. In 2012 is de opleiding erkend door de FONG op HBO-niveau. Sinds 2017 heeft de beroepsopleiding TOPKI het keurmerk: FONG.SNRO erkende HBO-opleiding.")])])])]),_vm._v(" "),_c('MainFooter',{staticStyle:{"display":"flex","margin-left":"auto","margin-right":"auto"}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('b',[_vm._v("Agenda Scholing:")]),_vm._v(" Studenten Topki en agenda nascholing Themadagen zie "),_c('a',{attrs:{"href":"https://www.topki.nl/trainer/suzette-frijters"}},[_vm._v("www.topki.nl/trainer/suzette-frijters")]),_c('br'),_vm._v("\n\t\t\t\t\tAanmelden graag via deze link."),_c('br'),_vm._v("\n\t\t\t\t\tHeeft u vragen dan graag een mail of telefoontje naar Suzette Frijters"),_c('br'),_vm._v("\n\t\t\t\t\ttel 0653574848")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("Dag 1: Talenten ontmoeten")]),_vm._v(" "),_c('li',[_vm._v("Dag 2: De Levensboom")]),_vm._v(" "),_c('li',[_vm._v("Dag 3: De Piramide")]),_vm._v(" "),_c('li',[_vm._v("Dag 4: De Zielespiegel")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("De beroepsopleiding "),_c('a',{attrs:{"href":"http://www.topki.nl/trainer/suzette-frijters"}},[_vm._v("TOPKI")]),_vm._v(" is door de SNRO geaccrediteerd. Voor deze beroepsopleiding verzorg ik een aantal scholingsprogramma’s. ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FqQ6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MainHeader__ = __webpack_require__("ejej");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainFooter__ = __webpack_require__("jJPo");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Nascholing",
  data: function data() {
    return {
      headerImage: __webpack_require__("qakt"),
      talentenspelVideo: __webpack_require__("ryIt"),
      nascholing_1: __webpack_require__("hUdH"),
      wereldBord: __webpack_require__("7xuk"),
      levensboomBord: __webpack_require__("qnT5"),
      piramideBord: __webpack_require__("TZpF"),
      zielespiegelBord: __webpack_require__("wyQW")
    };
  },

  computed: {},
  methods: {},
  components: {
    MainHeader: __WEBPACK_IMPORTED_MODULE_0__MainHeader__["a" /* default */],
    MainFooter: __WEBPACK_IMPORTED_MODULE_1__MainFooter__["a" /* default */]
  }
});

/***/ }),

/***/ "GazV":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/contact_header.939b134.jpg";

/***/ }),

/***/ "Gt18":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "I2Tb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__("PouT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a4f9bc24_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__("gFss");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a4f9bc24_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "I8j2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__recourses_menu__ = __webpack_require__("rs85");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'footer',
	data: function data() {
		return {
			menuItems: {},
			logo: __webpack_require__("BvKS")
		};
	},

	computed: {},
	methods: {},
	components: {},
	beforeMount: function beforeMount() {
		this.menuItems = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(__WEBPACK_IMPORTED_MODULE_1__recourses_menu__["a" /* menuItems */]));
		delete this.menuItems.demo;
		delete this.menuItems.contact;
		delete this.menuItems.gameofgifts;
	}
});

/***/ }),

/***/ "Jnt2":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/module_communicatie_counseling_header.8bb5380.jpg";

/***/ }),

/***/ "K99d":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/talentenspel.60acf7d.jpg";

/***/ }),

/***/ "KwkG":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/talentenspel_begeleiding_2.e2c8feb.jpg";

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c90bc0e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("k/Fq");
function injectStyle (ssrContext) {
  __webpack_require__("Ckkg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c90bc0e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M9J3":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/persoonlijke_supervisie_header2.2681bb0.jpg";

/***/ }),

/***/ "MfHO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'contact-form',
	data: function data() {
		return {};
	},

	computed: {},
	methods: {}
});

/***/ }),

/***/ "N3CM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"footer"},[_c('div',{staticStyle:{"text-align":"center","margin":"20px"}},[_c('p',{staticClass:"footer-text"},[_c('a',{attrs:{"target":"_blank","href":"https://www.herbergvanhethart.eu/Privacyverklaring-Herberg-van-het-Hart-05-2018.pdf"}},[_vm._v("Privacyverklaring")]),_vm._v(" "),_c('a',{staticStyle:{"margin-left":"25px"},attrs:{"target":"_blank","href":"https://www.herbergvanhethart.eu/Algemene-voorwaarden-Herberg-van-het-Hart-05-2018.pdf"}},[_vm._v("Algemene Voorwaarden")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
	el: '#app',
	router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
	template: '<App/>',
	components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "PMxc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('MainHeader',{attrs:{"page":'Contact'}}),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"whole component"},[_c('img',{attrs:{"src":_vm.headerImage,"width":"938px"}}),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('p',[_vm._v("Welkom bij Herberg van het Hart")]),_vm._v(" "),_c('p',[_vm._v("Voor informatie over begeleiding Talentenspel gelieve te mailen of bellen ")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('br'),_c('br'),_c('br'),_c('br'),_c('br'),_c('br'),_c('br'),_c('br'),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('MainFooter',{staticStyle:{"display":"flex","margin-left":"auto","margin-right":"auto"}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Tel: "),_c('br'),_vm._v(" +31(0)6-53574848"),_c('br'),_c('br'),_vm._v("\n\t\t\t\t\tEmail: "),_c('br'),_vm._v("suzette@herbergvanhethart.eu"),_c('br'),_c('br'),_vm._v("\n\t\t\t\t\tAdres: "),_c('br'),_vm._v(" Goudbaard 82 "),_c('br'),_vm._v("\n\t\t\t\t\t4625 GC "),_c('br'),_vm._v(" Bergen op Zoom")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticStyle:{"text-align":"center"}},[_c('i',[_vm._v("De schat die iemand in zijn diepste kern is helpen zichtbaar, hoorbaar en ervaarbaar te maken."),_c('br'),_vm._v("\n\t\t\t\t\t~ Suzette Frijters ~")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PouT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MainHeader__ = __webpack_require__("ejej");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainFooter__ = __webpack_require__("jJPo");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "demo",
  data: function data() {
    return {
      headerImage: __webpack_require__("B4SC")
    };
  },

  computed: {},
  methods: {},
  components: {
    MainHeader: __WEBPACK_IMPORTED_MODULE_0__MainHeader__["a" /* default */],
    MainFooter: __WEBPACK_IMPORTED_MODULE_1__MainFooter__["a" /* default */]
  }
});

/***/ }),

/***/ "RUe8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModuleCommunicatieCounseling_vue__ = __webpack_require__("pjFg");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a0e0408_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModuleCommunicatieCounseling_vue__ = __webpack_require__("Vko1");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModuleCommunicatieCounseling_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a0e0408_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModuleCommunicatieCounseling_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "SVxk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__recourses_menu__ = __webpack_require__("rs85");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "menu",
  data: function data() {
    return {
      menuItems: {},
      currentitems: []
    };
  },

  computed: {},
  methods: {
    highlightMenuItem: function highlightMenuItem(menuItem, solo) {
      document.getElementById(menuItem).style.cssText = "box-shadow: inset 0px 1px 1px #2D2F31; background-color: #BADAFA;";
      if (solo) {
        document.getElementById(menuItem).style.cssText += "border-radius: 5px;";
        document.getElementById("submenu").style.cssText = "background: none;";
      } else {
        document.getElementById("submenu").style.cssText = "background: #BADAFA;";
      }
    },
    mouseOver: function mouseOver(cat) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(document.getElementsByClassName("menu-item")), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var element = _step.value;

          element.style.cssText = "box-shadow: none; background-color: none; border-radius: 5px 5px 0 0;";
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      switch (cat) {
        case "Home":
          this.currentitems = this.menuItems.demo.sub;
          this.highlightMenuItem("menu_Home", true);
          break;
        case "Talentenspel":
          this.currentitems = this.menuItems.talentenspel.sub;
          this.highlightMenuItem("menu_Talentenspel", true);
          break;
        case "Talentenspel Begeleiding":
          this.currentitems = this.menuItems.coaching.sub;
          this.highlightMenuItem("menu_Talentenspel Begeleiding", true);
          break;
        case "Game of Gifts":
          this.currentitems = this.menuItems.gameofgifts.sub;
          this.highlightMenuItem("menu_Game of Gifts", true);
          break;
        case "Scholing":
          this.currentitems = this.menuItems.scholing.sub;
          this.highlightMenuItem("menu_Scholing");
          break;
        case "Bedrijven":
          this.currentitems = this.menuItems.bedrijven.sub;
          this.highlightMenuItem("menu_Bedrijven", true);
          break;
        case "Agenda":
          this.currentitems = this.menuItems.agenda.sub;
          this.highlightMenuItem("menu_Agenda", true);
          break;
        case "Contact":
          this.currentitems = this.menuItems.contact.sub;
          this.highlightMenuItem("menu_Contact", true);
          break;
      }
    }
  },
  props: ["page"],
  beforeMount: function beforeMount() {
    this.menuItems = __WEBPACK_IMPORTED_MODULE_1__recourses_menu__["a" /* menuItems */];
  },
  mounted: function mounted() {
    this.mouseOver(this.page);
  }
});

/***/ }),

/***/ "TP09":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"header"},[_c('div',{staticClass:"header-flex"},[_c('h1',{staticClass:"title"},[_vm._v("Herberg van het Hart")]),_vm._v(" "),_c('MainMenu',{attrs:{"page":_vm.page}})],1)]),_vm._v(" "),_c('div',{staticClass:"header-shadow"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TZpF":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/piramidebord_nl.4d25caa.jpg";

/***/ }),

/***/ "Tr3V":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/nascholing_header.8bb5380.jpg";

/***/ }),

/***/ "U3MO":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ktno_module.eedbee3.png";

/***/ }),

/***/ "UNTK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('MainHeader',{attrs:{"page":'Talentenspel'}}),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"whole component"},[_c('img',{attrs:{"src":_vm.headerImage,"width":"938px"}}),_vm._v(" "),_c('h1',[_vm._v("Talentenspel")]),_vm._v(" "),_c('p',{staticClass:"highlight"},[_vm._v("\n          Het Talentenspel is een instrument dat ontwikkeld is door Willem\n          Glaudemans. Om met deze methode te kunnen werken heb ik de opleiding\n          tot Talentencoach gevolgd en ben opgeleid tot gecertificeerd coach\n          en trainer Talentenspel met alle borden. Door de specifieke\n          speelwijze is het een uniek instrument om tot bewustwording te\n          komen.\n        ")]),_vm._v(" "),_c('p',{staticClass:"highlight"},[_vm._v("\n          Het Talentenspel is een archetypisch spel waarbij gebruik wordt\n          gemaakt van verschillende borden elk met zijn eigen unieke\n          werkwijze. Vanuit de metafoor van de koets met paarden gaan we\n          innerlijk op reis door deze borden. In de koets huist de ziel, op de\n          koets zit de majesteit en voor de koets lopen de paarden. De paarden\n          vertegenwoordigen de talenten. Deze reis, het Pad van de Held, neemt\n          de speler mee door het innerlijk Koninkrijk, wakkert zijn natuurlijk\n          leiderschap aan en geeft inzicht in het totale talententeam.\n        ")]),_vm._v(" "),_c('p',{staticClass:"highlight"},[_vm._v("\n          Het Talentenspel is een archetypisch spel waarbij gebruikt wordt\n          gemaakt van verschillende borden en de talenten.\n        ")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('p',{staticClass:"highlight"},[_vm._v("\n          Wilt u informatie over begeleiding met het Talentenspel neem dan\n          "),_c('router-link',{attrs:{"to":"/contact"}},[_vm._v("contact")]),_vm._v(" met mij op.\n        ")],1),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('iframe',{staticStyle:{"display":"block","height":"410px","width":"810px","padding":"0","margin":"auto","border":"0"},attrs:{"src":"https://www.herbergvanhethart.eu/imageslidermaker/example.html"}})])]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"half component"},[_c('img',{staticClass:"gameboard",attrs:{"src":_vm.nautilusBord}}),_vm._v(" "),_c('h2',[_vm._v("1. Het Nautilusbord")]),_vm._v(" "),_c('p',[_vm._v("\n          Het innerlijk kind en het natuurlijke groeiproces van iemands leven\n          wordt hierin duidelijk. Hoe ontwikkelen de talenten zich en hoe\n          ontwikkeld het jonge kind zich tot jong volwassene? Welke\n          begeleiders spelen een rol en hoe kom je tot een eigen keuze voor\n          opleiding of beroep?\n        ")])]),_vm._v(" "),_c('div',{staticClass:"half component"},[_c('img',{staticClass:"gameboard",attrs:{"src":_vm.jongPiramideBord}}),_vm._v(" "),_c('h2',[_vm._v("2. Jong Piramidebord")]),_vm._v(" "),_c('p',[_vm._v("\n          Richting in het leven van de jongeren die op zijn pad naar\n          volwassenheid het oude achter zich laat en zelf op pad gaat om zijn\n          droomwens te verwezenlijken.\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"half component"},[_c('img',{staticClass:"gameboard",attrs:{"src":_vm.wereldBord}}),_vm._v(" "),_c('h2',[_vm._v("3. Het Wereldbord")]),_vm._v(" "),_c('p',[_vm._v("\n          Harmonisatie en integratie. Het spelen van dit bord zorgt vooral\n          voor innerlijke schoonmaak. Vervorming van talenten worden\n          opgespoord en gezond gemaakt. De positie van de Koning(in) wordt\n          verhelderd en bekrachtigd.\n        ")])]),_vm._v(" "),_c('div',{staticClass:"half component"},[_c('img',{staticClass:"gameboard",attrs:{"src":_vm.levensboomBord}}),_vm._v(" "),_c('h2',[_vm._v("4. Het Levensboombord")]),_vm._v(" "),_c('p',[_vm._v("\n          Inzicht in richting en hiërarchie. Het spelen van dit bord zorgt\n          vooral voor uitzicht op de richting van het leven. Je krijgt inzicht\n          op je pad en je doel ofwel je missie, en richtingsgevoel.\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"half component"},[_c('img',{staticClass:"gameboard",attrs:{"src":_vm.piramideBord}}),_vm._v(" "),_c('h2',[_vm._v("5. Het Piramidebord")]),_vm._v(" "),_c('p',[_vm._v("\n          Manifestatie en Creatie. Het spelen van dit bord voegt een volgende\n          fase toe aan het proces. Dit bord brengt de missie op aarde, het\n          bord van incarnatie, concrete manifestatie van de missie in het\n          dagelijkse leven.\n        ")])]),_vm._v(" "),_c('div',{staticClass:"half component"},[_c('img',{staticClass:"gameboard",attrs:{"src":_vm.zielespiegelBord}}),_vm._v(" "),_c('h2',[_vm._v("6. Het Zielespiegelbord")]),_vm._v(" "),_c('p',[_vm._v("\n          Instrumentatie en zelfrealisatie. Het spelen van dit bord brengt de\n          verschillende innerlijke niveaus van de mens bijeen. Men gaat\n          ontdekken dat de missie niet vanuit een drang tot doen kan worden\n          vormgegeven, maar alleen als een spontane uitdrukking van 'zijn'.\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"half component"},[_c('img',{staticClass:"gameboard",attrs:{"src":_vm.bordVanEenheid}}),_vm._v(" "),_c('h2',[_vm._v("7. Bord van Eenheid")]),_vm._v(" "),_c('p',[_vm._v("\n          Thuis en Eenheid, Ervaring van Thuis komen. Alles komt samen. Zo\n          ziet Eenheid vanuit mijn ziel en vanuit mijn missie in totale Liefde\n          eruit. Dit bord kan alleen met het Zielespiegelbord samen ervaren\n          worden om de eenheid tussen jou en God te ervaren.\n        ")])]),_vm._v(" "),_c('div',{staticClass:"half component"},[_c('img',{staticClass:"gameboard",attrs:{"src":_vm.bordVanCreatie}}),_vm._v(" "),_c('h2',[_vm._v("8. Bord van Creatie")]),_vm._v(" "),_c('p',[_vm._v("Wat is creatie en scheppen en hoe werkt dit voor jou.")])])])]),_vm._v(" "),_c('MainFooter',{staticStyle:{"display":"flex","margin-left":"auto","margin-right":"auto"}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"highlight"},[_vm._v("\n          Ik ben opgeleid tot gecertificeerd coach en trainer met alle borden\n          van het Talentenspel. Voor meer informatie over het Talentenspel\n          kunt u terecht bij\n          "),_c('a',{attrs:{"href":"https://www.talentenspel.nl/"}},[_vm._v("www.talentenspel.nl")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"highlight"},[_c('b',[_vm._v("Heb jij het Talentenspel al een keer gespeeld? Dan is er nu een\n            mogelijkheid om het Talentenspel als traject te volgen door alle\n            acht borden, gegeven door Willem Glaudemans en Marjon te Riele.\n            "),_c('a',{attrs:{"target":"_blank","href":"https://www.herbergvanhethart.eu/talentenspel-8-daagse.pdf"}},[_vm._v("Hierbij de volledige uitnodiging")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"whole component"},[_c('h2',[_vm._v("Korte beschrijving van de borden")]),_vm._v(" "),_c('p',[_vm._v("\n          Om je inzicht te geven in de reis die je kunt maken binnen het\n          Talentenspel worden de borden hieronder in het kort beschreven. De\n          borden kunnen door elkaar gebruikt worden.\n        ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UyPe":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/nautilusbord_nl.e31724c.jpg";

/***/ }),

/***/ "Vko1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('MainHeader',{attrs:{"page":'Scholing'}}),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"whole component"},[_c('img',{attrs:{"src":_vm.headerImage,"width":"938px"}}),_vm._v(" "),_c('h1',[_vm._v("Module Communicatie en Counseling met het Talentenspel")]),_vm._v(" "),_c('p',{staticClass:"highlight"},[_vm._v("Persoonlijke supervisie is een verplicht onderdeel in de opleiding, dit traject is voor de ondersteuning en ontwikkeling van het persoonlijke groeiproces en loopt samen met Communicatie en Counseling (8 dagen), Talentenspel (4 dagen) en Vakdagen als een rode draad door de opleiding. Voor het vak van Professioneel Kinesioloog hebben we uiteindelijk vele kwaliteiten, vaardigheden en competenties nodig.")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('h2',[_vm._v("Vier losse modules van het Talentenspel")]),_vm._v(" "),_c('p',[_vm._v("Het Talentenspel is leidraad binnen deze vier verschillende modules die aansluitend na elkaar te volgen zijn voor de student tijdens in opleiding. Tijdens deze dagen zal de student verder ingaan op zijn of haar talenten, leiderschap, missie en manifestatie. Hierdoor wordt een bijdrage geleverd aan de Kinesioloog in opleiding en hoe zijn of haar praktijk vanuit het authentieke profiel kan worden vormgegeven.")])])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"quarter component"},[_c('img',{staticClass:"gameboard-small",attrs:{"src":_vm.wereldBord}})]),_vm._v(" "),_c('div',{staticClass:"quarter component"},[_c('img',{staticClass:"gameboard-small",attrs:{"src":_vm.levensboomBord}})]),_vm._v(" "),_c('div',{staticClass:"quarter component"},[_c('img',{staticClass:"gameboard-small",attrs:{"src":_vm.piramideBord}})]),_vm._v(" "),_c('div',{staticClass:"quarter component"},[_c('img',{staticClass:"gameboard-small",attrs:{"src":_vm.zielespiegelBord}})])]),_vm._v(" "),_vm._m(2)]),_vm._v(" "),_c('MainFooter',{staticStyle:{"display":"flex","margin-left":"auto","margin-right":"auto"}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"highlight"},[_vm._v("\n\t\t\t\t\t\tTijdelijk neemt Marjon te Riele de trainingen en bijscholingen voor Topki over. Meer informatie op haar\n\t\t\t\t\t\t"),_c('a',{attrs:{"href":"https://www.topki.nl/trainer/marjon-te-riele"}},[_vm._v("Topki pagina")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"half component"},[_c('h2',[_vm._v("Dag 1: "),_c('br'),_vm._v("Talenten ontmoeten")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Het Wereldbord:")]),_vm._v(" Harmonisatie en integratie Het spelen van dit bord zorgt vooral voor innerlijke schoonmaak. Vervorming van talenten worden opgespoord en gezond gemaakt. De positie van de koning(in) wordt verhelderd en bekrachtigd.")]),_vm._v(" "),_c('h2',[_vm._v("Dag 2: "),_c('br'),_vm._v("De Levensboom ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Het Levensboombord:")]),_vm._v(" Inzicht in richting en hiërarchie Het spelen van dit bord zorgt vooral voor uitzicht op de richting van het leven. Je krijgt inzicht op je pad en je doel ofwel je missie, en richtingsgevoel.")])]),_vm._v(" "),_c('div',{staticClass:"half component"},[_c('h2',[_vm._v("Dag 3: "),_c('br'),_vm._v("De Piramide ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Het Piramidebord:")]),_vm._v(" Manifestatie en Creatie Het spelen van dit bord voegt een volgende fase toe aan het proces. Dit bord brengt de missie op aarde, het bord van incarnatie, concrete manifestatie van de missie in het dagelijkse leven.")]),_vm._v(" "),_c('h2',[_vm._v("Dag 4: "),_c('br'),_vm._v("De Zielespiegel ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Het Zielespiegelbord:")]),_vm._v(" Instrumentatie en zelfrealisatie Het spelen van dit bord brengt de verschillende innerlijke niveaus van de mens bijeen. Men gaat ontdekken dat de missie niet vanuit een drang tot doen kan worden vormgegeven, maar alleen als een spontane uitdrukking van zijn.")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"whole component"},[_c('h2',[_vm._v("Accreditatie")]),_vm._v(" "),_c('p',[_vm._v("De beroepsopleiding "),_c('a',{attrs:{"href":"http://www.topki.nl/trainer/suzette-frijters"}},[_vm._v("TOPKI")]),_vm._v(" is door de SNRO geaccrediteerd. Voor deze beroepsopleiding verzorg ik een aantal scholingsprogramma’s. ")]),_vm._v(" "),_c('p',[_vm._v("De beroepsopleiding TOPKI voldoet aan de internationale voorwaarden van het International Kinesiology College en werkt samen met verschillende nationale- en internationale trainers. In 2012 is de opleiding erkend door de FONG op HBO-niveau. Sinds 2017 heeft de beroepsopleiding TOPKI het keurmerk: FONG.SNRO erkende HBO-opleiding.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XFFb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TalentenspelBegeleiding_vue__ = __webpack_require__("3S7q");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59266f51_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TalentenspelBegeleiding_vue__ = __webpack_require__("wVmx");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TalentenspelBegeleiding_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59266f51_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TalentenspelBegeleiding_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_pages_Home__ = __webpack_require__("I2Tb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pages_TalentenspelBegeleiding__ = __webpack_require__("XFFb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pages_Talentenspel__ = __webpack_require__("vTt4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pages_Scholing__ = __webpack_require__("/Cvj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pages_PersoonlijkeSupervisie__ = __webpack_require__("+JLh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_pages_ModuleCommunicatieCounseling__ = __webpack_require__("RUe8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_pages_Nascholing__ = __webpack_require__("y7iM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_pages_Contact__ = __webpack_require__("1eB3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_pages_ScholingTalentenspelCoaches__ = __webpack_require__("yArL");












__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: "hash",
  routes: [{
    path: "/",
    component: __WEBPACK_IMPORTED_MODULE_2__components_pages_Home__["a" /* default */]
    // {
    // 	path: '/talentenspel-begeleiding',
    // 	component: TalentenspelBegeleiding
    // },
    // {
    // 	path: '/talentenspel',
    // 	component: Talentenspel
    // },
    // {
    // 	path: '/scholing/persoonlijke-supervisie',
    // 	component: PersoonlijkeSupervisie
    // },
    // {
    // 	path: '/scholing/module-communicatie-counseling',
    // 	component: ModuleCommunicatieCounseling
    // },
    // {
    // 	path: '/scholing',
    // 	component: Scholing
    // },
    // {
    // 	path: '/scholing/nascholing',
    // 	component: Nascholing
    // },
    // {
    // 	path: '/scholing/scholing-talentenspel-coaches',
    // 	component: ScholingTalentenspelCoaches
    // },
    // {
    // 	path: '/contact',
    // 	component: Contact
    // }
  }]
}));

/***/ }),

/***/ "YpKm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Zln0":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bordvaneenheid_nl.1259c4a.jpg";

/***/ }),

/***/ "a/6Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('MainHeader',{attrs:{"page":'Scholing'}}),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"whole component"},[_c('img',{attrs:{"src":_vm.headerImage,"width":"938px"}}),_vm._v(" "),_c('h1',[_vm._v("Scholing Talentenspel Coaches")])])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"whole component"},[_c('p',[_vm._v("\n          We reizen door de 2 borden van het Jong Talentenspel, de 2\n          basisborden en de 4 verdiepingsborden. We boren de wijsheid aan van\n          elk bijpassend boek dat Willem heeft geschreven. En we tunen in op\n          jouw actuele ontwikkeling en thema's, de hogere trilling van deze\n          tijd, wat er voor je mogelijk is en hoe jij ten diepste bij wilt\n          dragen. Je kunt het zien als een inwijdingsweg, ontwikkeltraject en\n          professionele nascholing.\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          Onze ervaring is dat je in elke volgende fase van je eigen\n          ontwikkeling, de reis door jouw acht borden weer als een nieuw\n          inwijdingspad ervaart, of je nu wel of niet eerder met een aantal\n          van de borden hebt gewerkt.\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          Dit traject is voor coaches ook een voorwaarde om hierna de\n          certificeringstraining met de 4 verdiepingsborden te kunnen volgen,\n          zodat je er zelf met je klanten mee kunt werken.\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          Marjon heeft in een 8 minuten durende opname nog een keer de reis\n          met de acht borden beschreven, zodat je nog beter kunt ervaren hoe\n          het bij je past.\n        ")]),_vm._v(" "),_c('video',{attrs:{"controls":"","width":"100%"}},[_c('source',{attrs:{"src":_vm.talentenspelVideo,"type":"video/mp4"}})]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('p',[_vm._v("\n          Het is fijn om tijdig te weten of je mee wilt doen, i.v.m. het\n          reserveren van de ruimte en jouw plek. Mocht je je al hebben\n          opgegeven dan hoef je verder niks te doen.\n        ")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('p',[_vm._v("\n          Voor wie: Deze reis is geschikt voor Talentenspel coaches. En voor\n          hun klanten, mensen die al een persoonlijk traject bij een van de\n          coaches hebben gedaan.\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          Willem Glaudemans en Marjon te Riele\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          Heb je nog vragen over het traject: mail Marjon op\n          marjon@rosa-ligna.nl\n        ")])])])]),_vm._v(" "),_c('MainFooter',{staticStyle:{"display":"flex","margin-left":"auto","margin-right":"auto"}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"whole component"},[_c('p',[_vm._v("Talentenspel liefhebber,")]),_vm._v(" "),_c('p',[_vm._v("\n          graag nodigen we je uit voor een transformatieve reis door alle acht\n          Talentenspel borden, die van december tot april in vier modules van\n          twee dagen wordt gegeven door Willem Glaudemans en Marjon te Riele.\n        ")]),_vm._v(" "),_c('p',[_c('a',{attrs:{"target":"_blank","href":"https://www.herbergvanhethart.eu/talentenspel-8-daagse-coaches.pdf"}},[_vm._v("Hierbij de volledige uitnodiging")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"half component"},[_c('h3',[_vm._v("Data")]),_vm._v(" "),_c('p',[_c('ul',{staticStyle:{"display":"table","margin-right":"auto","margin-left":"auto"}},[_c('li',[_vm._v("Wo 13 en do 14 december 2023")]),_vm._v(" "),_c('li',[_vm._v("Ma 29 en di 30 januari 2024")]),_vm._v(" "),_c('li',[_vm._v("Ma 11 en di 12 maart 2024")]),_vm._v(" "),_c('li',[_vm._v("Ma 22 en di 23 april 2024")])])])]),_vm._v(" "),_c('div',{staticClass:"half component"},[_c('h3',[_vm._v("Locatie")]),_vm._v(" "),_c('p',[_vm._v("\n              De modules vinden plaats bij Zinn/Paaskerk, Oude Utrechtseweg\n              4A, 3743 KN in Baarn.\n            ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bg2o":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ktno_nascholing.0dcb663.png";

/***/ }),

/***/ "ejej":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainHeader_vue__ = __webpack_require__("obMu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d602d3b4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MainHeader_vue__ = __webpack_require__("TP09");
function injectStyle (ssrContext) {
  __webpack_require__("Gt18")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d602d3b4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MainHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gFss":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('MainHeader',{attrs:{"page":'Home'}}),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"whole component"},[_c('img',{attrs:{"src":_vm.headerImage,"width":"938px"}}),_vm._v(" "),_c('h1',[_vm._v("Herberg van het Hart")]),_vm._v(" "),_vm._m(0)])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',[_vm._v("\n          De schat die iemand in zijn diepste kern is helpen zichtbaar,\n          hoorbaar en ervaarbaar te maken."),_c('br'),_vm._v("\n          ~ Suzette Frijters ~\n        ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hPDa":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/scholing_header.f23a3cc.jpg";

/***/ }),

/***/ "hUdH":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/nascholing_1.3d5036a.jpg";

/***/ }),

/***/ "hp/p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MainHeader__ = __webpack_require__("ejej");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainFooter__ = __webpack_require__("jJPo");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Talentenspel",
  data: function data() {
    return {
      headerImage: __webpack_require__("K99d"),
      nautilusBord: __webpack_require__("UyPe"),
      jongPiramideBord: __webpack_require__("3PQc"),
      wereldBord: __webpack_require__("7xuk"),
      levensboomBord: __webpack_require__("qnT5"),
      piramideBord: __webpack_require__("TZpF"),
      zielespiegelBord: __webpack_require__("wyQW"),
      bordVanEenheid: __webpack_require__("Zln0"),
      bordVanCreatie: __webpack_require__("rDao"),
      bordVanMajesteit: __webpack_require__("vYFU"),
      bordVanMajesteit2: __webpack_require__("/xc6")
    };
  },

  computed: {},
  methods: {},
  components: {
    MainHeader: __WEBPACK_IMPORTED_MODULE_0__MainHeader__["a" /* default */],
    MainFooter: __WEBPACK_IMPORTED_MODULE_1__MainFooter__["a" /* default */]
  }
});

/***/ }),

/***/ "j1zl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact-form"},[_c('p',[_vm._v("Contact")]),_vm._v(" "),_c('form',{attrs:{"method":"POST","action":""}},[_c('div',{staticClass:"item"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Naam")]),_vm._v(" "),_c('input',{attrs:{"type":"text","id":"name","name":"name"}})]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('label',{attrs:{"for":"email"}},[_vm._v("E-mail")]),_vm._v(" "),_c('input',{attrs:{"type":"text","id":"email","name":"email"}})]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('label',{attrs:{"for":"telefoon"}},[_vm._v("Telefoon")]),_vm._v(" "),_c('input',{attrs:{"type":"text","id":"telefoon","name":"telefoon"}})]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('label',{attrs:{"for":"bericht"}},[_vm._v("Bericht")]),_vm._v(" "),_c('textarea',{attrs:{"id":"bericht","name":"bericht"}})]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('input',{staticStyle:{"width":"20px","height":"12pt","margin":"0"},attrs:{"type":"checkbox","name":"nieuwsbrief","id":"newsletter"}}),_vm._v(" "),_c('label',{staticStyle:{"width":"400px","text-align":"left"},attrs:{"for":"newsletter"}},[_vm._v("Ik wil me aanmelden voor de nieuwsbrief")])]),_vm._v(" "),_c('button',{attrs:{"type":"submit"}},[_vm._v("Verstuur")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jJPo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainFooter_vue__ = __webpack_require__("I8j2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f1330c84_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MainFooter_vue__ = __webpack_require__("N3CM");
function injectStyle (ssrContext) {
  __webpack_require__("YpKm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f1330c84_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MainFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "k/Fq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "obMu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MainMenu__ = __webpack_require__("x7p7");
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "header",
  data: function data() {
    return {};
  },

  computed: {},
  methods: {},
  components: {
    MainMenu: __WEBPACK_IMPORTED_MODULE_0__MainMenu__["a" /* default */]
  },
  props: ["page"]
});

/***/ }),

/***/ "pjFg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MainHeader__ = __webpack_require__("ejej");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainFooter__ = __webpack_require__("jJPo");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'Module-Communicatie-Counseling',
	data: function data() {
		return {
			headerImage: __webpack_require__("Jnt2"),
			wereldBord: __webpack_require__("7xuk"),
			levensboomBord: __webpack_require__("qnT5"),
			piramideBord: __webpack_require__("TZpF"),
			zielespiegelBord: __webpack_require__("wyQW")
		};
	},

	computed: {},
	methods: {},
	components: {
		MainHeader: __WEBPACK_IMPORTED_MODULE_0__MainHeader__["a" /* default */], MainFooter: __WEBPACK_IMPORTED_MODULE_1__MainFooter__["a" /* default */]
	}
});

/***/ }),

/***/ "qLe6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MainHeader__ = __webpack_require__("ejej");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainFooter__ = __webpack_require__("jJPo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ContactForm__ = __webpack_require__("wCbp");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'Contact',
	data: function data() {
		return {
			headerImage: __webpack_require__("GazV")
			// contactForm: require('../../contact-form/formpage.html')
		};
	},

	computed: {},
	methods: {},
	components: {
		MainHeader: __WEBPACK_IMPORTED_MODULE_0__MainHeader__["a" /* default */], MainFooter: __WEBPACK_IMPORTED_MODULE_1__MainFooter__["a" /* default */], ContactForm: __WEBPACK_IMPORTED_MODULE_2__ContactForm__["a" /* default */]
	}
});

/***/ }),

/***/ "qVmF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qakt":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/talentenspel-traject.2fadbed.jpg";

/***/ }),

/***/ "qnT5":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/levensboombord_nl.38d08f0.jpg";

/***/ }),

/***/ "rDao":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bordvancreatie_nl.ad1ebc2.jpg";

/***/ }),

/***/ "rs85":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return menuItems; });
var menuItems = {
	demo: {
		main: { text: 'Home', link: '/' },
		sub: [] },
	talentenspel: {
		main: { text: 'Talentenspel', link: '/talentenspel' },
		sub: []
	},
	coaching: {
		main: { text: 'Talentenspel Begeleiding', link: '/talentenspel-begeleiding' },
		sub: [] },
	scholing: {
		main: { text: 'Scholing', link: '/scholing' },
		sub: [{ text: 'Persoonlijke Supervisie', link: '/scholing/persoonlijke-supervisie' }, { text: 'Module Communicatie / Counseling Topki', link: '/scholing/module-communicatie-counseling' }, { text: 'Nascholing', link: '/scholing/nascholing' }, { text: 'Scholing Talentenspel Coaches', link: '/scholing/scholing-talentenspel-coaches' }] },
	contact: {
		main: { text: 'Contact', link: '/contact' },
		sub: [] }
};

/***/ }),

/***/ "ryIt":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/talentenspel-traject.2fa576a.mp4";

/***/ }),

/***/ "s/40":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vTt4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Talentenspel_vue__ = __webpack_require__("hp/p");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57c8189e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Talentenspel_vue__ = __webpack_require__("UNTK");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Talentenspel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57c8189e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Talentenspel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "vYFU":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bord_majesteit_3.e72fbe4.jpg";

/***/ }),

/***/ "vnkJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu",on:{"mouseleave":function($event){return _vm.mouseOver(_vm.page)}}},[_c('br'),_vm._v(" "),_c('br')])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "w+BS":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/talentenspel_begeleiding_1.51af868.jpg";

/***/ }),

/***/ "wCbp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactForm_vue__ = __webpack_require__("MfHO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2feeecc4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactForm_vue__ = __webpack_require__("j1zl");
function injectStyle (ssrContext) {
  __webpack_require__("s/40")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2feeecc4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wVmx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('MainHeader',{attrs:{"page":'Talentenspel Begeleiding'}}),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"whole component"},[_c('img',{attrs:{"src":_vm.headerImage,"width":"938px"}}),_vm._v(" "),_c('h1',[_vm._v("Talentenspel Begeleiding")]),_vm._v(" "),_c('p',{staticClass:"highlight"},[_vm._v("In mijn praktijk wordt er ingegaan op levensvragen die wij allemaal hebben. We worden geraakt door situaties in ons leven die we willen onderzoeken. Vragen die vaak gaan over een diepere betekenis van het leven zelf. Wie ben ik, waarom ben ik hier, wat kom ik hier doen? Waarom ben ik in dit gezin geboren, hoe ga ik om met scheiding, verlies, afscheid en/of wie staat mij bij als ik het even niet meer ziet zitten?")]),_vm._v(" "),_c('p',{staticClass:"highlight"},[_vm._v("Mijn werk als coach / counselor gaat over het meelopen op iemands levenspad. Naast iemand staan of lopen betekent voor mij het innerlijk proces bij de ander zijn werk laten doen. Het betekent letterlijk laten ontvouwen wat er zichtbaar mag worden.  Hierin komt mijn missie het meest tot zijn recht.")]),_vm._v(" "),_vm._m(0)])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"whole component"},[_vm._m(4),_vm._v(" "),_c('p',[_vm._v("Wilt u informatie over bovenstaande begeleidingstrajecten neem dan "),_c('router-link',{attrs:{"to":"/contact"}},[_vm._v("contact")]),_vm._v(" met mij op. ")],1)])])]),_vm._v(" "),_c('MainFooter',{staticStyle:{"display":"flex","margin-left":"auto","margin-right":"auto"}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"highlight",staticStyle:{"text-align":"center"}},[_c('i',[_vm._v("~ De schat die iemand in zijn diepste kern is, helpen zichtbaar, hoorbaar en ervaarbaar te maken. ~")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"half component"},[_c('h2',[_vm._v("De begeleiding")]),_vm._v(" "),_c('p',[_vm._v("In de begeleiding wordt gebruik gemaakt van het Talentenspel of het Jong Talent als basis. Er zijn verschillende borden van het Talentenspel waarmee gewerkt wordt.")]),_vm._v(" "),_c('p',[_vm._v("Tijdens de begeleiding met het Talentenspel kunnen aanvullende oefeningen worden gebruikt. Dit kunnen bijvoorbeeld meditatie oefeningen, Mindfulness en / of creatieve opdrachten zijn.")])]),_vm._v(" "),_c('div',{staticClass:"half component"},[_c('h2',[_vm._v("Individuele begeleiding: waar en hoe vaak is een gesprek nodig?")]),_vm._v(" "),_c('p',[_vm._v("Een individuele begeleiding met het Talentenspel vraagt 3 tot 5 sessies van elk 2 ½ uur. Hierin werken we alleen met de basisborden van het Talentenspel of Jong Talent. Een tijdsinvestering van zo’n 10 uur gemiddeld.")]),_vm._v(" "),_c('p',[_vm._v("Samen bepalen we de periode waarin de begeleiding plaatsvindt. Tussen twee afspraken zit minimaal twee weken. Dit geeft de ruimte om hetgeen wat bewust gemaakt is met het spel ook te kunnen integreren. Er kunnen opdrachten worden meegegeven voor de tussenliggende periode.")]),_vm._v(" "),_c('p',[_vm._v("Na het basistraject bestaat de mogelijkheid begeleid te worden met de verdiepingsborden.")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"whole component"},[_c('h2',[_vm._v("Voor wie?")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"whole component",staticStyle:{"padding":"0 200px"}},[_c('p',[_vm._v("Begeleiding is geschikt voor als je bijvoorbeeld met de volgende vragen rondloopt;"),_c('br'),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Je loopt rond met levensvragen en zoekt naar antwoorden.")]),_vm._v(" "),_c('li',[_vm._v("Je staat op de drempel maar durft er niet overheen.")]),_vm._v(" "),_c('li',[_vm._v("Je ervaart angsten voor datgene wat innerlijk gevraagd wordt om een stap te nemen.")]),_vm._v(" "),_c('li',[_vm._v("Je bent op zoek naar bezieling en bewustwording.")]),_vm._v(" "),_c('li',[_vm._v("Je bent op zoek naar de opleiding of beroep die het meest bij jou past.")]),_vm._v(" "),_c('li',[_vm._v("Je wilt jouw innerlijke schat zichtbaar maken, maar wie ben jij echt?")]),_vm._v(" "),_c('li',[_vm._v("Je hebt een burn-out (gehad) en je mag nieuwe keuzes maken, durf je dat?")]),_vm._v(" "),_c('li',[_vm._v("Loop je vast in je huidige baan en wil je helderheid hebben over jouw talenten, jouw leiderschap en jouw missie?")]),_vm._v(" "),_c('li',[_vm._v("Je wilt een bedrijf starten en je bent op zoek naar jouw missie voor dit bedrijf.")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Ik ben opgeleid tot gecertificeerd coach en trainer met alle borden van het Talentenspel. Voor meer informatie over het Talentenspel kunt u terecht bij "),_c('a',{attrs:{"href":"https://www.talentenspel.nl/"}},[_vm._v("www.talentenspel.nl")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wYB5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MainHeader__ = __webpack_require__("ejej");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainFooter__ = __webpack_require__("jJPo");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'Nascholing',
	data: function data() {
		return {
			headerImage: __webpack_require__("Tr3V"),
			nascholing_1: __webpack_require__("hUdH"),
			wereldBord: __webpack_require__("7xuk"),
			levensboomBord: __webpack_require__("qnT5"),
			piramideBord: __webpack_require__("TZpF"),
			zielespiegelBord: __webpack_require__("wyQW")
		};
	},

	computed: {},
	methods: {},
	components: {
		MainHeader: __WEBPACK_IMPORTED_MODULE_0__MainHeader__["a" /* default */], MainFooter: __WEBPACK_IMPORTED_MODULE_1__MainFooter__["a" /* default */]
	}
});

/***/ }),

/***/ "wyQW":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/zielespiegelbord_nl.0ae4aa1.jpg";

/***/ }),

/***/ "x4QM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('MainHeader',{attrs:{"page":'Scholing'}}),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"whole component"},[_c('img',{attrs:{"src":_vm.headerImage,"width":"938px"}}),_vm._v(" "),_c('h1',[_vm._v("Persoonlijke Supervisie voor studenten in opleiding")]),_vm._v(" "),_c('p',[_vm._v("Persoonlijke supervisie is een verplicht onderdeel in de opleiding, dit traject is voor de ondersteuning en ontwikkeling van het persoonlijke groeiproces en loopt samen met Communicatie en Counseling  (8 dagen) , Talentenspel ( 4 dagen) en Vakdagen als een rode draad door de opleiding. Voor het vak van Professioneel Kinesioloog hebben we uiteindelijk vele kwaliteiten, vaardigheden en competenties nodig.")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('p',[_vm._v("De student bekijkt samen met een van de begeleiders het ontwikkelingsplan en overlegt aan welke ontwikkelingsstappen gewerkt wordt tijdens de supervisie en/of andere benodigde begeleiding. Er wordt in de regel 1 uur tijd gereserveerd, waarbij de student het uurtarief aan de begeleider betaalt. Het minimum aantal uren over het gehele studietraject is 12 uur, verdeeld over vier jaar. In overleg met de begeleider kan er gekozen worden voor een uitbreiding van het aantal benodigde uren.  ")]),_vm._v(" "),_c('p',[_vm._v("Doordat ik het Talentenspel als leidraad inzet tijdens de supervisie gesprekken duren deze 2 uur per sessie. De persoonlijke supervisie in combinatie met het Talentenspel brengt de student inzicht en oefening in alle bovenstaande gebieden. Vanuit integriteit en respect voor de student behandelen we in vertrouwen persoonlijke stukken. Het volgen van het individuele traject Talentenspel geeft geen vrijstelling voor de module Communicatie en Counseling. Beiden maken gebruik van het instrument Talentenspel, echter verschillen van invulling en doelstelling.")]),_vm._v(" "),_c('p',[_vm._v("Wilt u informatie over persoonlijke supervisie neem dan "),_c('router-link',{attrs:{"to":"/contact"}},[_vm._v("contact")]),_vm._v(" met mij op.")],1),_vm._v(" "),_c('h2',[_vm._v("Accreditatie")]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('p',[_vm._v("De beroepsopleiding TOPKI voldoet aan de internationale voorwaarden van het International Kinesiology College en werkt samen met verschillende nationale- en internationale trainers. In 2012 is de opleiding erkend door de FONG op HBO-niveau. Sinds 2017 heeft de beroepsopleiding TOPKI het keurmerk: FONG.SNRO erkende HBO-opleiding.")])])])]),_vm._v(" "),_c('MainFooter',{staticStyle:{"display":"flex","margin-left":"auto","margin-right":"auto"}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('b',[_vm._v("Agenda Scholing:")]),_vm._v(" Studenten Topki en agenda nascholing Themadagen zie "),_c('a',{attrs:{"href":"https://www.topki.nl/trainer/suzette-frijters"}},[_vm._v("www.topki.nl/trainer/suzette-frijters")]),_c('br'),_vm._v("\n\t\t\t\t\tAanmelden graag via deze link."),_c('br'),_vm._v("\n\t\t\t\t\tHeeft u vragen dan graag een mail of telefoontje naar Suzette Frijters"),_c('br'),_vm._v("\n\t\t\t\t\ttel 0653574848")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Persoonlijk ontwikkelingsplan van TOPKI"),_c('br'),_vm._v(" "),_c('ol',[_c('li',[_vm._v("Kennis hebben van en werken volgens het Educatieve Model (Vanaf het eerste jaar)")]),_vm._v(" "),_c('li',[_vm._v("Kennis hebben van en werken volgens de Ethische Code van het IKC (Vanaf het eerste jaar)")]),_vm._v(" "),_c('li',[_vm._v("Zelfevaluatie (Vanaf het tweede jaar)")]),_vm._v(" "),_c('li',[_vm._v("Zelfverantwoordelijkheid (Vanaf het tweede jaar)")]),_vm._v(" "),_c('li',[_vm._v("Zelfstandigheid (Vanaf het derde jaar)")]),_vm._v(" "),_c('li',[_vm._v("Kennis hebben van en ontwikkeling naar het Beroepsprofiel (Vanaf het derde jaar)")]),_vm._v(" "),_c('li',[_vm._v("Visie en Missie (Vanaf het vierde jaar)")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("De beroepsopleiding "),_c('a',{attrs:{"href":"http://www.topki.nl/trainer/suzette-frijters"}},[_vm._v("TOPKI")]),_vm._v(" is door de SNRO geaccrediteerd. Voor deze beroepsopleiding verzorg ik een aantal scholingsprogramma’s. ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "x7p7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainMenu_vue__ = __webpack_require__("SVxk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b7078dde_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MainMenu_vue__ = __webpack_require__("vnkJ");
function injectStyle (ssrContext) {
  __webpack_require__("qVmF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b7078dde_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MainMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'app'
});

/***/ }),

/***/ "y7iM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Nascholing_vue__ = __webpack_require__("wYB5");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fc200ef6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Nascholing_vue__ = __webpack_require__("CR37");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Nascholing_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fc200ef6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Nascholing_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "yArL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ScholingTalentenspelCoaches_vue__ = __webpack_require__("FqQ6");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_648a47e0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ScholingTalentenspelCoaches_vue__ = __webpack_require__("a/6Z");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ScholingTalentenspelCoaches_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_648a47e0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ScholingTalentenspelCoaches_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "zoqq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MainHeader__ = __webpack_require__("ejej");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainFooter__ = __webpack_require__("jJPo");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'Scholing',
	data: function data() {
		return {
			headerImage: __webpack_require__("hPDa"),
			wereldBord: __webpack_require__("7xuk"),
			levensboomBord: __webpack_require__("qnT5"),
			piramideBord: __webpack_require__("TZpF"),
			zielespiegelBord: __webpack_require__("wyQW"),
			ktno_nascholing: __webpack_require__("bg2o"),
			ktno_module: __webpack_require__("U3MO")
		};
	},

	computed: {},
	methods: {},
	components: {
		MainHeader: __WEBPACK_IMPORTED_MODULE_0__MainHeader__["a" /* default */], MainFooter: __WEBPACK_IMPORTED_MODULE_1__MainFooter__["a" /* default */]
	}
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.be0c954c081dd079eb4f.js